import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LOOKUP_REGISTRY, DomainKey, ResourceKey, LookupConfigEntry } from './lookup-registry';
import type { FetchOptions } from './common-lookup.type';
import { ApiCollectionResponse } from '@shared/types/api/api-collection-response';

type FetchArgs =
  | []
  | readonly [Readonly<FetchOptions>]
  | [term?: string, offset?: number, limit?: number];

@Injectable({ providedIn: 'root' })
export class CommonLookupService {
  constructor (private readonly http: HttpClient) {}

  fetch<T>(domain: DomainKey, resource: ResourceKey, ...rest: readonly []): Observable<ApiCollectionResponse<T>>;
  fetch<T>(domain: DomainKey, resource: ResourceKey, ...rest: readonly [Readonly<FetchOptions>]): Observable<ApiCollectionResponse<T>>;
  fetch<T>(domain: DomainKey, resource: ResourceKey, ...rest: readonly [term?: string, offset?: number, limit?: number]): Observable<ApiCollectionResponse<T>>;

  fetch<T>(
    domain: DomainKey,
    resource: ResourceKey,
    ...rest: FetchArgs
  ): Observable<ApiCollectionResponse<T>> {
    let term: string;
    let offset: number;
    let limit: number;

    if (rest.length !== 0 && rest.length === 1 && typeof rest[ 0 ] === 'object') {
      const opt: FetchOptions = rest[ 0 ];

      term = opt.term ?? '';
      offset = opt.offset ?? 0;
      limit = opt.limit ?? 25;
    } else {
      const [ t, o, l ]: readonly [string | undefined, number | undefined, number | undefined] = rest as unknown as readonly [string | undefined, number | undefined, number | undefined];

      term = String(t ?? '');
      offset = o ?? 0;
      limit = l ?? 25;
    }

    const domainCfg: (typeof LOOKUP_REGISTRY)[DomainKey] = LOOKUP_REGISTRY[ domain ];
    const resCfg: LookupConfigEntry | undefined = domainCfg.resources[ resource ];

    if (!resCfg) throw new Error(`Lookup config missing for ${ domain }/${ resource }`);

    let params: HttpParams = new HttpParams()
      .set('fields', resCfg.fields)
      .set('limit', String(limit))
      .set('offset', String(offset))
      .set("fulltext", term);

    if (resCfg.sort)
      params = params.set('sort', resCfg.sort);


    return this.http
      .get<ApiCollectionResponse<T>>(`${ domainCfg.basePath }/${ resource }`, { params });
  }
}
